export enum WrapUpOutcomePolicy {
  Completed = 0,
  Reschedule = 1,
}
